import swiper from './swiper.vue';

import slide from './slide.vue';

export default {
  swiper,
  slide,
};